/**
 * ⑭ R14a — 탐색 «자리(slot)» 2종. 지역 칩·검색의 실제 동작은 R14b 몫이다 — 여기는 기본값만 그린다.
 *
 *   NavRegionSlot  기본: 「전국」 정적 칩 → /apt/region (지역 허브 색인). 서버 HTML 항상 「전국」.
 *   NavSearchSlot  기본: /search 로 가는 검색 아이콘 링크(데스크톱은 글자 「검색」 동반).
 *
 * 통합 방법(R14b): 이 파일의 두 함수 «본문» 을 R14b 컴포넌트로 바꾸면 끝이다. 호출부는 둘 —
 *   · NavV2 마스트헤드   <NavRegionSlot surface="mast" /> · <NavSearchSlot surface="mast" />
 *   · KdPageHead 2줄 우측 <NavRegionSlot surface="pagehead" />
 * props 계약: surface 는 계측(region_chip_open·search_open 의 event_name)과 스타일 분기에 쓴다.
 *   className 은 자리 크기를 잡는 바깥 클래스(kd-slot--*)로, 교체 컴포넌트도 그대로 받아 폭을 고정한다(시프트 0).
 *
 * ⛔ 훅 없음 · 서버/클라이언트 어디서나 렌더 가능 · 방문자 무관(같은 URL = 같은 HTML).
 */
// ⑭ 통합: 본문 = R14b GlobalRegionChip·GlobalSearch(nav-slot-bodies, 클라이언트 섬). 바깥 span(폭 고정)은 그대로.
import { RegionSlotBody, SearchSlotBody } from './nav-slot-bodies';

export type NavSlotSurface = 'mast' | 'pagehead';

export interface NavRegionSlotProps {
  surface: NavSlotSurface;
  className?: string;
}

export function NavRegionSlot({ surface, className }: NavRegionSlotProps) {
  return (
    <span className={['kd-slot', 'kd-slot--region', `kd-slot--${surface}`, className].filter(Boolean).join(' ')} data-nav-slot="region">
      <RegionSlotBody surface={surface} />
    </span>
  );
}

export interface NavSearchSlotProps {
  surface: NavSlotSurface;
  className?: string;
}

export function NavSearchSlot({ surface, className }: NavSearchSlotProps) {
  return (
    <span className={['kd-slot', 'kd-slot--search', `kd-slot--${surface}`, className].filter(Boolean).join(' ')} data-nav-slot="search">
      <SearchSlotBody />
    </span>
  );
}
